import { render, staticRenderFns } from "./baseForm.vue?vue&type=template&id=04be9888&scoped=true"
import script from "./baseForm.vue?vue&type=script&lang=js"
export * from "./baseForm.vue?vue&type=script&lang=js"
import style0 from "./baseForm.vue?vue&type=style&index=0&id=04be9888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be9888",
  null
  
)

export default component.exports